import { useState, useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';  // Import generateClient from aws-amplify/api
import * as subscriptions from '../graphql/subscriptions';  // Import the subscription (e.g. onCreateTransaction)
import { listTransactions } from '../graphql/queries';  // Import the query to list transactions

const RealTimeTransactionsAWS = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Generate the API client
  const client = generateClient();

  // Fetch the initial transactions
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const result = await client.graphql({
          query: listTransactions,  // Use the query to fetch transactions
        });

        setTransactions(result.data.listTransactions.items);  // Set state with fetched transactions
      } catch (error) {
        console.error('Error fetching transactions:', error);
      } finally {
        setLoading(false);  // Set loading to false after fetch
      }
    };

    fetchTransactions();  // Fetch the initial transactions when component mounts

    // Subscribe to real-time updates when a new transaction is created
    const createSub = client
      .graphql({ query: subscriptions.onCreateTransaction })  // Use the onCreateTransaction subscription
      .subscribe({
        next: ({ data }) => {
          const newTransaction = data.onCreateTransaction;  // Extract new transaction from the subscription response
          setTransactions((prevTransactions) => [newTransaction, ...prevTransactions]);  // Update state with new transaction
        },
        error: (error) => {
          console.warn('Subscription error:', error);  // Handle any subscription errors
        },
      });

    // Subscribe to real-time updates when a transaction is updated
    const updateSub = client
      .graphql({ query: subscriptions.onUpdateTransaction })  // Use the onUpdateTransaction subscription
      .subscribe({
        next: ({ data }) => {
          const updatedTransaction = data.onUpdateTransaction;
          setTransactions((prevTransactions) => {
            return prevTransactions.map((transaction) =>
              transaction.id === updatedTransaction.id ? updatedTransaction : transaction
            );
          });
        },
        error: (error) => {
          console.warn('Subscription error:', error);
        },
      });

    // Subscribe to real-time updates when a transaction is deleted
    const deleteSub = client
      .graphql({ query: subscriptions.onDeleteTransaction })  // Use the onDeleteTransaction subscription
      .subscribe({
        next: ({ data }) => {
          const deletedTransaction = data.onDeleteTransaction;
          setTransactions((prevTransactions) => {
            return prevTransactions.filter((transaction) => transaction.id !== deletedTransaction.id);
          });
        },
        error: (error) => {
          console.warn('Subscription error:', error);
        },
      });

    // Cleanup subscriptions on component unmount
    return () => {
      createSub.unsubscribe();
      updateSub.unsubscribe();
      deleteSub.unsubscribe();
    };
  }, []);  // The empty dependency array ensures this runs only once when the component mounts

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>Transactions</h1>
      <ul>
        {transactions.map((transaction) => (
           <li key={transaction.id}>
           <strong>Transaction ID:</strong> {transaction.transaction_id} <br />
           <strong>Document Name:</strong> {transaction.document_name} <br />
           <strong>Status:</strong> {transaction.transaction_status} <br />
           <strong>Payment Status:</strong> {transaction.transaction_payment_status} <br />
           <strong>Date Created:</strong> {transaction.date_created} <br />
           <strong>Date Released:</strong> {transaction.date_released} <br />
           <strong>Price:</strong> ${transaction.document_price} <br />
           {/* You can display more fields as necessary */}
           <hr />
       </li>
        ))}
      </ul>
    </div>
  );
};

export default RealTimeTransactionsAWS;
